<template>
  <div class="home">
    <su-screen
        v-if="tabList && tabList.length > 0"
        :tab="queryParams.tab"
        :tabList="tabList"
        @tabClick="tabClick"/>
    <su-list v-loading="loading" :list="list"/>
    <div class="flex ju-cn" v-if="list && list.length > 0">
      <pagination
          v-show="total > 0"
          :total="total"
          layout="prev, pager, next"
          :page.sync="queryParams.page"
          :limit.sync="queryParams.pagesize"
          @pagination="chapterlists"
      />
    </div>
  </div>
</template>

<script>
import {chapterlists, indexCourse, userInfo} from "@/api/api";
import {mapState} from 'vuex'
import SuList from "@/components/su-list/su-list.vue";
import SuScreen from "@/components/su-screen/su-screen.vue";

export default {
  components: {SuScreen, SuList},
  data() {
    return {
      loading: false,
      // 显示搜索条件
      showSearch: true,
      tabList: [],
      // 总条数
      total: 2,
      // 表格数据
      list: [],
      queryParams: {
        tab: '',
        page: 1,
        pagesize: 10,
      },
    };
  },
  computed: {
    ...mapState(['token', 'userInfo', 'setting']),
  },
  created() {
    this.indexCourse()
  },
  mounted() {

  },
  methods: {
    // 课程
    indexCourse() {
      indexCourse({
        cid: 1,
      }).then(res => {
        if (res.code === 200 && res.data && res.data.length > 0) {
          this.tabList = [{
            "id": '',
            "category_name": "全部"
          }]
          this.tabList = this.tabList.concat(res.data)
          this.chapterlists()
        }
      })
    },
    tabClick(item) {
      this.queryParams.tab = item.id
      this.chapterlists()
    },
    chapterlists() {
      if (this.loading) return
      this.loading = true;
      chapterlists(this.queryParams).then(response => {
        if (response.code === 200) {
          this.list = response.data.data;
          this.total = response.data.total;
        }
        this.loading = false;
      });
    },
    // 获取设置
    getSetting() {
      getSetting().then(res => {
        if (res.code === 1) {
          this.$store.commit('setSetting', res.data)
        }
      })
    },
    // 获取用户信息
    postuserInfo() {
      userInfo().then(res => {
        if (res.code === 1) {
          this.$store.commit('setUserInfo', res.data)
        }
      })
    },

  }
};
</script>

<style lang="scss" scoped>

</style>
